// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`should match snapshot 1`] = `
.c0 {
  border-color: #fff;
}

.c0::-webkit-outer-spin-button,
.c0::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.c0 input[type=number] {
  -moz-appearance: textfield;
}

<div
  className="relative flex"
>
  <input
    className="c0 bg-white text-black p-3 rounded-2xl border-1 h-full w-full focus:outline-none"
    onChange={[Function]}
    placeholder="Zip Code"
    type="number"
  />
</div>
`;



//////////////////
// WEBPACK FOOTER
// ./app/javascript/bundles/ui/Forms/Zipcode/__snapshots__/index.test.jsx.snap
// module id = 2642
// module chunks = 6